export type AppDownloadSettings = {
    customFileNameKeys: string[]
    expandOutputColumns: boolean
    includeMessages: boolean
    includeAnnotations: boolean
    flattenTables: boolean
    excludeHeaderRow: boolean
    fieldDelimiter: string
    quoteValues: boolean
    sendEmail: boolean
    saveSettings: boolean
}

export type AppTTLSettings = {
    onCompleted: {
        ttlInSeconds: number
        enabled: boolean
    }
}

export type AppInboxSettings = {
    id: string
    address: string
}

export type AppSettings = {
    downloadSettings: AppDownloadSettings
    postProcessing: boolean
    ttlSettings: AppTTLSettings
}

export type AppSettingsUpdate = {
    downloadSettings?: Partial<AppDownloadSettings>
    postProcessing?: boolean
    ttlSettings?: AppTTLSettings
}

export const defaultAppSettings: AppSettings = {
    downloadSettings: {
        customFileNameKeys: [],
        expandOutputColumns: true,
        includeMessages: false,
        includeAnnotations: false,
        flattenTables: true,
        excludeHeaderRow: false,
        fieldDelimiter: ",",
        quoteValues: false,
        sendEmail: true,
        saveSettings: false
    },
    postProcessing: false,
    ttlSettings: {
        onCompleted: {
            ttlInSeconds: 60,
            enabled: false
        }
    }
}
